import { CheckGroupChangeArgs } from '@modules/timetable';

/**
 * If user is trying to change the group, show proper error message
 * @param currentGroup
 * @param newGroup
 * @param addToast
 */
export const checkGroupChange = ({ currentGroup, newGroup, addToast }: CheckGroupChangeArgs): boolean => {
  const currentGroupType = currentGroup.split('/')[0];
  const newGroupType = newGroup.split('/')[0];

  // Prevent moving to a group of different type
  if (currentGroupType !== newGroupType) {
    addToast(`Error. You cannot move a ${currentGroupType} to a ${newGroupType} slot.`, {
      appearance: 'error',
      autoDismiss: true,
    });

    return false;
  }

  // Prevent moving to an unselected group
  if (currentGroup !== newGroup) {
    addToast(`Error. You can only modify the selected class.`, {
      appearance: 'error',
      autoDismiss: true,
    });

    return false;
  }

  return true;
};
